import React, { useEffect, useMemo, useState } from 'react';
import { Clock3, Phone } from 'lucide-react';
import { useT } from '../utils/i18n';
import { LiveOrderTicker } from './LiveOrderTicker';
const PHONE_NUMBER = '(206) 619-3742';
const SLOGAN_KEYS = ['announce.slogan.sameDay', 'announce.slogan.bulkDelivery', 'announce.slogan.direct', 'announce.slogan.familyOwned', 'announce.slogan.realTrucks', 'announce.slogan.tacoma'] as const;
type DispatchStatus = {
  isActive: boolean;
  opensIn: string;
};
export function AnnouncementBar() {
  const t = useT();
  const [dispatchStatus, setDispatchStatus] = useState<DispatchStatus>(() => getDispatchStatus());
  const sloganKey = useMemo(() => SLOGAN_KEYS[Math.floor(Math.random() * SLOGAN_KEYS.length)], []);
  useEffect(() => {
    const timer = window.setInterval(() => setDispatchStatus(getDispatchStatus()), 30_000);
    return () => window.clearInterval(timer);
  }, []);
  return <div className="relative z-[60] bg-[#2E2121] px-4 py-1.5 text-white" data-id="element-157" data-mp="1qb79zrrdu2dm">
      <div className="mx-auto flex max-w-7xl items-center gap-2 sm:gap-3" data-id="element-158" data-mp="67qntc931l50">
        <LiveOrderTicker isDispatchActive={dispatchStatus.isActive} data-id="element-159" data-mp="6amkyyd3w5se" />
        {!dispatchStatus.isActive && <>
            <div className="hidden shrink-0 items-center gap-1.5 border-l border-white/15 pl-3 text-[11px] font-semibold tabular-nums text-white/65 sm:inline-flex" aria-live="polite" data-id="element-160" data-mp="3sfq7mclgx943">
              <Clock3 className="h-3.5 w-3.5 text-white/45" aria-hidden="true" data-id="element-161" data-mp="1b05sjdpwfgy" />
              <span data-id="element-162" data-mp="p0ukl6hlke3u">{dispatchStatus.opensIn}</span>
            </div>
            <p className="hidden min-w-0 shrink items-center border-l border-white/15 pl-3 text-xs font-medium text-white/45 lg:flex" data-id="element-163" data-mp="twt5gk3pvdzi">
              {t(sloganKey)}
            </p>
          </>}
        <a href="tel:206-619-3742" aria-label={`Call ${PHONE_NUMBER}`} className="inline-flex h-7 shrink-0 items-center justify-center border-l border-white/20 px-3 text-xs font-semibold tracking-tight text-[#00b774] transition-colors hover:text-white md:justify-start md:gap-1.5 md:pl-4 md:pr-0 md:text-sm" data-id="element-164" data-mp="k6zr5bc6wkrk">
          <Phone className="h-4 w-4 text-[#00b774]" data-id="element-165" data-mp="1mizux4n03agu" />
          <span className="hidden whitespace-nowrap md:inline" data-id="element-166" data-mp="1hl81g66pjgaj">{PHONE_NUMBER}</span>
        </a>
      </div>
    </div>;
}
function getDispatchStatus(): DispatchStatus {
  const pacificNow = new Date(new Date().toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles'
  }));
  const day = pacificNow.getDay();
  const hour = pacificNow.getHours();
  const isSaturday = day === 6;
  const isSunday = day === 0;
  const closingHour = isSaturday ? 15 : 17;
  const isActive = !isSunday && hour >= 6 && hour < closingHour;
  if (isActive) return {
    isActive: true,
    opensIn: ''
  };
  const nextOpen = new Date(pacificNow);
  nextOpen.setSeconds(0, 0);
  if (isSunday) {
    nextOpen.setDate(nextOpen.getDate() + 1);
  } else if (hour >= closingHour) {
    nextOpen.setDate(nextOpen.getDate() + (isSaturday ? 2 : day === 5 ? 3 : 1));
  }
  nextOpen.setHours(6, 0, 0, 0);
  const remainingMinutes = Math.max(0, Math.ceil((nextOpen.getTime() - pacificNow.getTime()) / 60_000));
  const hours = Math.floor(remainingMinutes / 60);
  const minutes = remainingMinutes % 60;
  return {
    isActive: false,
    opensIn: `Opens in ${hours}h ${minutes}m`
  };
}